import { LoadingSpinner } from "@/components/loading-spinner";
import { H2 } from "@/components/typography";

import { DataTable } from "@/components/data-table";
import { columnsCPM, columnsERP, columnsEfficiency, columnsOverview, columnsPricing } from "./columns";

import { addRangeFields } from "../../efficiency/ranges";

type CalibrationTablesProps = {
  data?: any;
  error?: any;
  isMutating?: any;
};

const decimalFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  maximumSignificantDigits: 3,

  notation: "compact",
  compactDisplay: "short",
});

function CalibrationTables({ data, error, isMutating }: CalibrationTablesProps): JSX.Element {
  if (isMutating) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div>Error: {JSON.stringify(error.serverError)}</div>;
  }

  if (!data) {
    return <p className="text-muted-foreground">Run the analysis above.</p>;
  }

  if (!data.results || data.results.length == 0) {
    return <p>There is no data for the selected filters. Try again with other combinations</p>;
  }

  data.results = addRangeFields(data.results, "InstallsPerCostBucket", "Total");

  return (
    <>
      {data.meta && (
        <p>
          Query completed in {decimalFormatter.format(data.meta.Took / 1e9)} seconds, processed{" "}
          {decimalFormatter.format(data.meta.TotalBytesProcessed / 1e9)} GB which cost{" "}
          {usdFormatter.format(data.meta.CostUSD)}.
        </p>
      )}

      <H2>Overview</H2>
      <DataTable columns={columnsOverview} data={data.results} />

      <H2>ERP Calibration</H2>
      <DataTable columns={columnsERP} data={data.results} />

      <H2>CPM Calibration</H2>
      <DataTable columns={columnsCPM} data={data.results} />

      <H2>Bid Pricing</H2>
      <DataTable columns={columnsPricing} data={data.results} />

      <H2>Bidding Efficiency</H2>
      <DataTable columns={columnsEfficiency} data={data.results} />
    </>
  );
}

export default CalibrationTables;
